export const MATE_LANE_CODE: string = 'mate-request-lane';
export const MATE_LANE_CODE_FX: string = 'mate-request-lane-fx';
export const MATE_PRECACHE_MICRO: string = 'mate-precache-micro';
export const MATE_STATS = 'mate-client-stats';
export const BRAND_MAP = {
  alps: '乐道',
  nio: '蔚来',
  fy: '萤火虫',
};
export * from './pageEnum';
export * from './settingEnum';
